module.exports = __webpack_public_path__ + "static/media/tinywow_2173Cocos nucifera_colored_55475306.7670f021.jpg";